import { render } from "./AudienceDetails.vue?vue&type=template&id=14317811"
import script from "./AudienceDetails.vue?vue&type=script&lang=js"
export * from "./AudienceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__